// @ts-nocheck
import { useRequestQuery } from '../../useQueryRequest';
import { useDownloadFile } from '../../useDownloadFile';
import { useRequestPdf } from '../../useRequestPdf';
import t from '../types';

/**
 * Retrieve donors transactions report.
 */
export function useDonorsTransactionsReport(query, props) {
  return useRequestQuery(
    [t.FINANCIAL_REPORT, t.DONORS_TRANSACTIONS, query],
    {
      method: 'get',
      url: '/financial_statements/transactions-by-donors',
      params: query,
      headers: {
        Accept: 'application/json+table',
      },
    },
    {
      select: (res) => ({
        data: res.data.table,
        tableRows: res.data.table.rows,
      }),
      defaultData: {
        tableRows: [],
        data: [],
      },
      ...props,
    },
  );
}

export const useDonorsTransactionsXlsxExport = (query, args) => {
  const url = '/financial_statements/transactions-by-donors';
  const config = {
    headers: {
      accept: 'application/xlsx',
    },
    params: query,
  };
  const filename = 'donors_transactions.xlsx';

  return useDownloadFile({
    url,
    config,
    filename,
    ...args,
  });
};

export const useDonorsTransactionsCsvExport = (query, args) => {
  return useDownloadFile({
    url: '/financial_statements/transactions-by-donors',
    config: {
      headers: {
        accept: 'application/csv',
      },
      params: query,
    },
    filename: 'donors_transactions.csv',
    ...args,
  });
};

/**
 * Retrieves the pdf content of donors transactions.
 */
export const useDonorsTransactionsPdfExport = (query = {}) => {
  return useRequestPdf({
    url: '/financial_statements/transactions-by-donors',
    params: query,
  });
};
